import { render, staticRenderFns } from "./PhieuKhamBenhDetail.vue?vue&type=template&id=2b6739f4&scoped=true"
import script from "./PhieuKhamBenhDetail.vue?vue&type=script&lang=js"
export * from "./PhieuKhamBenhDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6739f4",
  null
  
)

export default component.exports